import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'

/* Router Modules */
import newsRouter from './modules/news'
import linkRouter from './modules/link'
import videoRouter from './modules/video'
import meetingRouter from './modules/meeting'
import formRouter from './modules/form'
import topicRouter from './modules/topic'
import expoRouter from './modules/expo'
import vipRouter from './modules/vip'
import myRouter from './modules/my'
import userRouter from './modules/user'
import surveyRouter from './modules/survey'
import cardRouter from './modules/card'
import activityRouter from './modules/activity'
// import adminNewsRouter from './modules/admin/news'
import adminAdRouter from './modules/admin/ad'
import adminExpoRouter from './modules/admin/expo'
import adminSignRouter from './modules/admin/sign'
import adminSurveyRouter from './modules/admin/survey'
// import meetingSignRouter from './modules/m_sign'
import adminMeetingRouter from './modules/admin/meeting'
import adminCardRouter from './modules/admin/card'
// import adminMeetingSignRouter from './modules/admin/meetingSign'
import adminDownloadRouter from './modules/admin/download'
import adminFormRouter from './modules/admin/form'
import adminLinkRouter from './modules/admin/link'
// import adminPictureRouter from './modules/admin/pic'
import adminVideoRouter from './modules/admin/video'
import adminIndexRouter from './modules/admin'
import adminPrinterRouter from './modules/admin/printer'
import adminLiveRouter from './modules/admin/live'
import adminSubscribeRouter from './modules/admin/subscribe'
import orderRouter from './modules/order'
import contactsRouter from './modules/contacts'
import luckyRouter from './modules/lucky'
import libraryRouter from './modules/library'
import liveRouter from './modules/live'
import adminActivityRouter from './modules/admin/activity'
import adminContactsRouter from './modules/admin/contacts'
import adminLuckyRouter from './modules/admin/lucky'
import adminLibraryRouter from './modules/admin/library'
import adminWpRouter from './modules/admin/wp'
// import adminCertRouter from './modules/admin/cert'
import adminExhibitorRouter from './modules/admin/exhibitor'

Vue.use(Router)

export default new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: store.getters.token ? '/contacts' : '/t'
    },
    // {
    //   path: '/redirect',
    //   name: 'Redirect',
    //   component: () => import('@/views/error/redirect')
    // },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import('@/views/auth/logout')
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/views/auth/login')
    },
    {
      path: '/register',
      name: 'Register',
      component: () => import('@/views/auth/register')
    },
    {
      path: '/login1',
      name: 'Login1',
      component: () => import('@/views/auth/login1')
    },
    {
      path: '/register1',
      name: 'Register1',
      component: () => import('@/views/auth/register1')
    },
    ...linkRouter,
    ...newsRouter,
    ...videoRouter,
    ...meetingRouter,
    ...formRouter,
    // ...meetingSignRouter,
    ...topicRouter,
    ...expoRouter,
    ...vipRouter,
    ...userRouter,
    ...cardRouter,
    ...orderRouter,
    ...luckyRouter,
    ...libraryRouter,
    ...contactsRouter,
    ...myRouter,
    ...surveyRouter,
    ...activityRouter,
    ...liveRouter,
    // ...adminNewsRouter,
    ...adminIndexRouter,
    ...adminExhibitorRouter,
    ...adminAdRouter,
    ...adminExpoRouter,
    ...adminSignRouter,
    ...adminSurveyRouter,
    ...adminMeetingRouter,
    // ...adminMeetingSignRouter,
    ...adminDownloadRouter,
    // ...adminPictureRouter,
    ...adminVideoRouter,
    ...adminPrinterRouter,
    ...adminActivityRouter,
    ...adminLiveRouter,
    ...adminContactsRouter,
    ...adminLuckyRouter,
    ...adminLibraryRouter,
    ...adminFormRouter,
    ...adminLinkRouter,
    ...adminSubscribeRouter,
    ...adminCardRouter,
    ...adminWpRouter,
    // ...adminCertRouter,
    {
      path: '/sign/:id(\\d+)',
      name: 'SignDetail',
      component: () => import('@/views/sign/detail')
    },
    {
      path: '/sign/:id(\\d+)/yes',
      name: 'SignDetailYes',
      component: () => import('@/views/sign/yes')
    },
    {
      path: '/sign/:sign_id(\\d+)/:user_id(\\d+)',
      name: 'SignView',
      component: () => import('@/views/sign/view')
    },
    {
      path: '/sign/result',
      name: 'SignResult',
      component: () => import('@/views/sign/result')
    },
    {
      path: '/s',
      name: 'SearchIndex',
      component: () => import('@/views/search/index')
    },
    {
      path: '/s/e',
      name: 'SearchExpo',
      component: () => import('@/views/search/expo')
    },
    {
      path: '/v/:id',
      redirect: '/e/:id'
    },
    {
      path: '/contacts/index',
      redirect: '/contacts'
    },
    {
      path: '/c/:id',
      redirect: to => {
        const { params, query } = to
        if (query.return_vid) {
          return {
            name: 'EpDetail',
            params: { id: params.id },
            query: { expo: query.return_vid }
          }
        } else {
          return {
            name: 'EpDetail',
            params: { id: params.id }
          }
        }
      }
    },
    {
      path: '/term',
      name: 'Term',
      component: () => import('@/views/term')
    },
    {
      path: '/wx_notice',
      name: 'WxNotice',
      component: () => import('@/views/error/wx_notice')
    },
    {
      path: '/file_preview',
      name: 'FilePreview',
      component: () => import('@/views/file_preview')
    },
    {
      path: '/download',
      name: 'FileDownload',
      component: () => import('@/views/download')
    },
    {
      path: '/confirm_mobile',
      name: 'ConfirmMobile',
      component: () => import('@/views/confirm_mobile')
    },
    {
      path: '/403',
      name: '403',
      component: () => import('@/views/error/403')
    },
    {
      path: '/404',
      name: '404',
      component: () => import('@/views/error/404')
    },
    {
      path: '/test',
      name: 'Test',
      meta: {
        keepAlive: true
      },
      component: () => import('@/views/test/test1')
    },
    { path: '*', redirect: '/404', hidden: true }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js